export const actionType = {
  ARTICLE_DETAIL_REQUEST: 'ARTICLE_DETAIL_REQUEST',
  ARTICLE_DETAIL_RESPONSE: 'ARTICLE_DETAIL_RESPONSE',  
  ARTICLE_DETAIL_API_REQUEST: "ARTICLE_DETAIL_API_REQUEST",
  ARTICLE_DETAIL_API_SUCCESS: "ARTICLE_DETAIL_API_SUCCESS",
  ARTICLE_DETAIL_API_FAILURE: "ARTICLE_DETAIL_API_FAILURE",    
  FB_API_REQUEST: "FB_API_REQUEST",  
  FB_API_SUCCESS: "FB_API_SUCCESS",  
  FB_API_FAILURE: "FB_API_FAILURE",
  ACCESS_FP_API_REQUEST: "ACCESS_FP_API_REQUEST",  
  ACCESS_FP_API_SUCCESS: "ACCESS_FP_API_SUCCESS",  
  ACCESS_FP_API_FAILURE: "ACCESS_FP_API_FAILURE", 
  ACCESS_FP_UPDATE_API_REQUEST: "ACCESS_FP_UPDATE_API_REQUEST",  
  ACCESS_FP_UPDATE_API_SUCCESS: "ACCESS_FP_UPDATE_API_SUCCESS",  
  ACCESS_FP_UPDATE_API_FAILURE: "ACCESS_FP_UPDATE_API_FAILURE",   
}

/**
 *  @getProductCategories method to get the product category for search page listing
 *  @input: null
 *  @output: json object of categories
 */
export const getPageDataAction = () => ({
  type: actionType.ARTICLE_DETAIL_REQUEST
});


/**
 * @getArticleDetailAction method to get the article detail
 * @input: articleId
 * @output: Object of article content
 */
export const getArticleDetailAction = (articleId) => ({
  type: actionType.ARTICLE_DETAIL_API_REQUEST, payload:articleId
})

/**
 * @method: saveFeedbackAction
 * @param: articleId,feedback
 * @returns: status: success/faliure
 */
export const saveFeedbackAction = (fbRequestData) => ({
  type: actionType.FB_API_REQUEST, payload:fbRequestData
})


/**
 * @method: SaveAccessFootPrintAction : to save access footprint
 * @param:  AddAccessLogRequest Object
 * @returns: Object
 */

 export const SaveAccessFootPrintAction = (reqData) => ({
    type: actionType.ACCESS_FP_API_REQUEST, payload: reqData
 })

 
/**
 * @method : UpdateAccessFootPrintAction to save access footprint
 * @param:  AddAccessLogRequest Object
 * @returns: Object
 */

export const UpdateAccessFootPrintAction = (reqData) => ({
  type: actionType.ACCESS_FP_UPDATE_API_REQUEST, payload: reqData
})

